import dayjs from 'dayjs'

/**
 * 前端存储
 * @param name
 * @param value
 */
export const setStorage = (name: string, value: any) => {
  window.localStorage.setItem(name, value)
}

/**
 * 获取存储
 * @param name
 * @returns
 */
export const getStorage = (name: string) => {
  return window.localStorage.getItem(name) || null
}

/**
 * 删除存储
 * @param name
 */
export const deleteStorage = (name: string) => {
  window.localStorage.removeItem(name)
}

/**
 * 获取微信授权地址
 * @param appId
 */
export const getWechatAuthUrl = (appId: string, redirectUrl: string, scope: string = 'snsapi_base') => {
  return `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appId}&redirect_uri=${redirectUrl}&response_type=code&scope=${scope}&state=STATE#wechat_redirect`
}

/**
 * 获取飞书授权地址
 * @param clientId
 * @param redirectUrl
 * @param scope
 * @returns
 */
export const getFeishuUrl = (clientId: string, redirectUrl: string, scope: string = 'contact:user.base:readonly') => {
  // 飞书拿到code后，获取授权用户信息时，需要将此授权地址一并提交
  window.localStorage.setItem('auth_redirect_uri', redirectUrl)
  return `https://accounts.feishu.cn/open-apis/authen/v1/authorize?client_id=${clientId}&redirect_uri=${redirectUrl}&scope=${scope}&state=MEIYANG`
}

/**
 * 获取地址栏参数
 * @param key
 */
export const getURLSearchParams = (key: string): string | null => {
  const params = new URLSearchParams(window.location.search)
  return params.get(key) || null
}

/**
 * 根据身份证号获取性别
 * @param idCard 18位身份证号
 * @returns
 */
export const getGenderFromIdCard = (idCard: string): number => {
  // 检查身份证号是否为18位
  if (idCard.length !== 18) {
    return 1
  }

  // 提取第17位数字
  const genderDigit = parseInt(idCard.charAt(16), 10)

  // 判断奇偶性
  if (genderDigit % 2 === 0) {
    return 0
  } else {
    return 1
  }
}

/**
 * 获取相差天数天数
 * @param value
 */
export const getDiffDay = (startTime: any, endTime?: any) => {
  if (!startTime) return 0

  const d1 = new Date(startTime)
  let d2 = new Date()
  if (endTime) {
    d2 = new Date(endTime)
  }

  // 获取时间戳（以毫秒为单位）
  const timestamp1 = d1.getTime()
  const timestamp2 = d2.getTime()

  // 计算时间差（以毫秒为单位）
  const timeDifference = Math.abs(timestamp2 - timestamp1)

  // 将毫秒转换为天数（1天 = 1000毫秒 * 60秒 * 60分钟 * 24小时）
  return Math.ceil(timeDifference / (1000 * 60 * 60 * 24))
}

/**
 * 地址栏数据解码
 * @param str
 * @returns
 */
export const deepDecodeURIComponent = (str: string) => {
  let decoded = decodeURIComponent(str)
  while (decoded !== str) {
    str = decoded
    decoded = decodeURIComponent(str)
  }
  return decoded
}

/**
 * 拼接路径
 * @param args
 * @returns
 */
export const joinpath = (...args: string[]) => {
  const strs = args.map((u: string) => u.replace(/^\/+|\/+$/g, ''))

  const _url = strs.join('/')
  if (!_url.startsWith('/')) {
    return '/' + _url
  }

  return _url
}

/**
 * 文件大小格式化
 * @param size
 */
export const sizeFormat = (size: string | number): string => {
  if (!size) return '0 K'

  const _size = parseInt(size + '')

  if (_size >= 1073741824) {
    return `${(_size / 1073741824).toFixed(2)} G`
  } else if (_size < 1073741824 && _size >= 1048576) {
    return `${(_size / 1048576).toFixed(2)} M`
  } else {
    return `${(_size / 1024).toFixed(0)} K`
  }
}

/**
 * 格式化时间
 * @param value
 * @param format
 * @returns
 */
export const dateFormat = (value: any, format = 'YYYY-MM-DD HH:mm:ss'): string => {
  if (!value) return '--'
  return dayjs(value || new Date()).format(format)
}

/**
 * 判断是否在微信内置浏览器中（不含企业微信）
 */
export const isWeChat = () => {
  const ua = navigator.userAgent
  return /micromessenger/i.test(ua) && !/wxwork/i.test(ua)
}

/**
 * 如果包含企业微信
 * @returns
 */
export const isWeChatOrWork = () => {
  const ua = navigator.userAgent
  return /micromessenger/i.test(ua)
}

/**
 * 判断是否为飞书环境
 * @returns
 */
export const isFeiShu = () => {
  const ua = navigator.userAgent
  return /Lark|FeiShu/i.test(ua)
}
